import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.loaded = false
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  async toggle(event) {
    event.stopPropagation()

    if (this.panelTarget.style.display === "none") {
      await this.open()
    } else {
      this.close()
    }
  }

  async open() {
    if (!this.loaded) {
      await get("/in_app_notifications", { responseKind: "turbo-stream" })
      this.loaded = true
    }
    this.panelTarget.style.display = "block"
    setTimeout(() => {
      document.addEventListener("click", this.boundHandleClickOutside)
    }, 0)
  }

  close() {
    this.panelTarget.style.display = "none"
    document.removeEventListener("click", this.boundHandleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
